// Defines the landing route for each restricted role.

import type { RoleName } from '@/stores/permissions.store';

export const DEFAULT_LANDING_PATH = '/';

/** Client review dashboard — the only page a Client Restricted User can reach. */
export const CLIENT_REVIEW_PATH = '/sentinel-conversations';

/** Agent workspace — a Sentinel user's home, opening on the brand picker. */
export const SENTINEL_WORKSPACE_PATH = '/sentinel-workspace';

/** Older links name the ticket as `?ticket=1300`. */
export const SENTINEL_TICKET_PARAM = 'ticket';

const SENTINEL_TICKET_PATH = /^\/sentinel-workspace\/tickets\/(\d+)\/?$/;

/** A Sentinel ticket's own page: `/sentinel-workspace/tickets/1300`. */
export function sentinelTicketPath(ticketId: number): string {
	return `${SENTINEL_WORKSPACE_PATH}/tickets/${ticketId}`;
}

/** The ticket a workspace URL names, from its path or an older `?ticket=`. */
export function sentinelTicketIdFromUrl(pathname: string, search: URLSearchParams): number | null {
	const id = Number(SENTINEL_TICKET_PATH.exec(pathname)?.[1] ?? search.get(SENTINEL_TICKET_PARAM));
	return Number.isSafeInteger(id) && id > 0 ? id : null;
}

const ROLE_LANDING_PATH: Partial<Record<RoleName, string>> = {
	client_restricted: CLIENT_REVIEW_PATH,
	sentinel: SENTINEL_WORKSPACE_PATH
};

/** The path this role should be sent to in place of the home dashboard. */
export function getLandingPath(role: RoleName | null | undefined): string {
	if (!role) return DEFAULT_LANDING_PATH;
	return ROLE_LANDING_PATH[role] ?? DEFAULT_LANDING_PATH;
}

/** True when the role is scoped to one dashboard rather than the whole app. */
export function hasDedicatedLanding(role: RoleName | null | undefined): boolean {
	return getLandingPath(role) !== DEFAULT_LANDING_PATH;
}
